import { gql } from '@apollo/client'

// Status of a file started by EXPORT_CSV_FILE_MUTATION: pending → processing → completed | failed.
export const EXPORT_FILE_QUERY = gql`
	query exportFile($id: String!) {
		exportFile(id: $id) {
			id
			name
			status
			downloadUrl
			fileSize
		}
	}
`
